import { useReduxState } from 'hooks';
import { Link } from 'components/common';

const PageFooter = ({
  footerContent,
  showAdditionalTerms,
  showVuolearningTerms
}: {
  footerContent?: string;
  showAdditionalTerms?: boolean;
  showVuolearningTerms?: boolean;
}) => {
  const {
    language,
    messages,
    serverConfig: { registerAdditionalTermsLinks },
    theme
  } = useReduxState();

  const termsLinks = [
    ...(showVuolearningTerms
      ? [
          {
            href:
              language === 'fi-FI'
                ? 'https://www.vuolearning.com/fi/user-terms'
                : 'https://www.vuolearning.com/en/user-terms',
            text: messages.consentTermsOfService
          },
          {
            href:
              language === 'fi-FI'
                ? 'https://www.vuolearning.com/fi/platform-privacy-policy'
                : 'https://www.vuolearning.com/en/platform-privacy-policy',
            text: messages.consentPrivacyPolicy
          }
        ]
      : []),
    ...(showAdditionalTerms ? registerAdditionalTermsLinks : [])
  ];

  return (
    <footer className="footer" id="footer">
      {footerContent ? (
        <div className="container">
          <div
            className="custom-content"
            dangerouslySetInnerHTML={{ __html: footerContent }}
          />
        </div>
      ) : null}

      {showVuolearningTerms || showAdditionalTerms ? (
        <div className="container">
          <div
            className={`links ${footerContent ? 'with-custom-content' : ''}`}
          >
            {termsLinks.map((termsLink, i) => (
              <div className="link" key={i}>
                <Link
                  external={true}
                  href={termsLink.href}
                  openInNewTab={true}
                  openInNewTabIcon={false}
                  text={termsLink.text}
                  {...(theme.footerTextColor
                    ? { style: { color: theme.footerTextColor } }
                    : {})}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <style jsx>{`
        .footer {
          background-color: ${theme.footerBackgroundColor || 'white'};
          color: ${theme.footerTextColor || theme.textColorLight};
          font-size: 1.5rem;
          padding: 15px;
          width: 100%;
        }
        .custom-content :global(a) {
          color: ${theme.footerTextColor || 'inherit'};
          text-decoration: underline;
        }
        .links {
          text-align: center;
        }
        .links.with-custom-content {
          border-top: 1px solid ${theme.lightGrey};
          margin-top: 15px;
          padding-top: 10px;
        }
        .link {
          display: inline-block;
          margin: 0 20px;
        }
      `}</style>
    </footer>
  );
};

export default PageFooter;
